import * as React from 'react';
import styled from 'styled-components';
import { fromScreen } from '@doltech/core/lib/responsive/responsive.util';

import { Button } from '../../../figma/ButtonV2/ButtonV2';
import { colorsV2 } from '../../../figma/colors-v2';
import { Divider } from '../../../figma/Divider/Divider';
import { Link } from '../../../figma/Link';
import { GridContentV2 } from '../PageSectionStructure/Content/GridContentV2';
import { PageSectionStructureV2 } from '../PageSectionStructure/PageSectionStructureV2';
import { RelatedPostCardDolVn, RelatedPostCardDolVnModel } from './RelatedPostCardDolVn';
import { IconInterfaceEssentialNews } from '@doltech/icons-from-dev/IconInterfaceEssentialNews';

const ReadMore = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Main = styled.section`
  padding-bottom: 32px;
  padding-left: 16px;
  padding-right: 16px;

  ${fromScreen(458)} {
    margin: 0 auto;
    width: 425px;
    padding-left: 0;
    padding-right: 0;
  }
  ${fromScreen(776)} {
    width: 712px;
  }
`;

interface ReadMoreModel {
  url: string;
  text?: string;
}

interface RelatedPostsDolVnProps {
  data: RelatedPostCardDolVnModel[];
  readMore?: ReadMoreModel;
}

export const RelatedPostsDolVnBase = (props: RelatedPostsDolVnProps) => {
  const { data, readMore } = props;

  return (
    <Main>
      <PageSectionStructureV2
        icon={<IconInterfaceEssentialNews fontSize={32} color="black100" />}
        title="Bài viết liên quan"
        content={
          <GridContentV2
            withRowDivider
            data={data}
            renderCard={(cardData) => <RelatedPostCardDolVn data={cardData} />}
            gridColumn={[
              {
                breakpoint: 767,
                numOfColumn: 1,
              },
              {
                breakpoint: 1024,
                numOfColumn: 1,
              },
            ]}
          />
        }
      />

      {Boolean(readMore) && (
        <>
          <Divider.Line color={colorsV2.black20} space={32} />
          <ReadMore href={readMore.url}>
            <Button.Primary>{readMore.text || 'Đọc thêm'}</Button.Primary>
          </ReadMore>
        </>
      )}
    </Main>
  );
};
